import { useContext } from "react";
import { RyftCardPaymentContext } from "./RyftCardPaymentProvider.shared";

export type { SafeReturnType } from "./RyftCardPaymentProvider.shared";

export const useRyftPayment = () => {
  const context = useContext(RyftCardPaymentContext);

  if (!context) {
    throw new Error(
      "useRyftPayment() must be used within <RyftCardPaymentProvider />",
    );
  }

  return context;
};

export type UseRyftPaymentReturnType = ReturnType<typeof useRyftPayment>;
